import { apiClient } from '@/shared/api';
import type { PhraseAuditItem, PhraseListParams, PhraseListResponse } from './types';

/**
 * Получить страницу перечня реплик диалогов: GET /phrase.
 * Имена условий приводит к контракту бэкенда общий интерцептор (`durationFrom` → `duration-from`).
 */
export const fetchPhrases = async (params?: PhraseListParams): Promise<PhraseListResponse> => {
  const { data } = await apiClient.get<PhraseListResponse>('/phrase', { params });
  return data;
};

/**
 * Сохранить правленый текст реплики: PATCH /phrase/{id}.
 */
export const updatePhraseText = async (id: number, text: string): Promise<PhraseAuditItem> => {
  const { data } = await apiClient.patch<PhraseAuditItem>(`/phrase/${id}`, { text });
  return data;
};
